import { useMemo } from 'react';
import { SageTokens } from '@kajabi/sage-react';

import { CheckoutConfigData } from '../types';

const DEFAULT_SHADOW = 'none';
const DEFAULT_BORDER_TYPE = 'solid';
const DEFAULT_BORDER_RADIUS = '0px';

// hardcoded for now, until we can vet the values from DSS
const SHADOWS = {
  small: ' 0px 0px 12px 1px #0000003d',
  medium: ' 0px 0px 25px 5px #0000003d',
  large: ' 0px 0px 40px 12px #0000003d',
  none: 'none',
};

const useCheckoutLayoutStyles = (data: CheckoutConfigData = {} as CheckoutConfigData) =>
  useMemo(() => {
    const {
      checkoutPageBoxShadow,
      checkoutPageBorderColor,
      checkoutPageBorderWidth,
      checkoutPageBorderRadius,
      checkoutPageBorderType,
      checkoutPageColor,
    } = data || {};

    const style: React.CSSProperties = {
      width: '100%',
      overflow: 'hidden',
    };

    // Box Shadow
    if (
      checkoutPageBoxShadow &&
      typeof checkoutPageBoxShadow === 'string' &&
      Object.prototype.hasOwnProperty.call(SHADOWS, checkoutPageBoxShadow)
    ) {
      style.boxShadow = SHADOWS[checkoutPageBoxShadow as keyof typeof SHADOWS];
    } else {
      style.boxShadow = SHADOWS[DEFAULT_SHADOW];
    }

    // Border Type
    if (checkoutPageBorderType) {
      style.borderStyle = checkoutPageBorderType;
    } else if (checkoutPageBorderColor || checkoutPageBorderWidth) {
      style.borderStyle = DEFAULT_BORDER_TYPE;
    }

    // Border Color
    if (checkoutPageBorderColor) {
      style.borderColor = checkoutPageBorderColor;
    }

    // Border Width (0-50px)
    style.borderWidth = checkoutPageBorderWidth ? `${checkoutPageBorderWidth}px` : '0px';

    // Border Radius (0-50px)
    style.borderRadius = checkoutPageBorderRadius
      ? `${checkoutPageBorderRadius}px`
      : DEFAULT_BORDER_RADIUS;

    style.background = SageTokens.COLOR_PALETTE.WHITE;
    style.height = '100%';

    return style;
  }, [
    data.checkoutPageBoxShadow,
    data.checkoutPageBorderColor,
    data.checkoutPageBorderWidth,
    data.checkoutPageBorderRadius,
    data.checkoutPageBorderType,
    data.checkoutPageColor,
  ]);

export default useCheckoutLayoutStyles;
